module.exports = __webpack_public_path__ + "img/recommand.126fd132.png";